"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIncrementedDirtyIndex = getIncrementedDirtyIndex;
exports.getCurrentDirtyIndex = getCurrentDirtyIndex;
let dirtyIndex = 0;
function getIncrementedDirtyIndex() {
    dirtyIndex++;
    return dirtyIndex;
}
function getCurrentDirtyIndex() {
    return dirtyIndex;
}
